import type {Moment} from 'moment-timezone'

export type ParsableTimeRange<T = Moment> = [start: T, end: T]
export type MomentRange = ParsableTimeRange<Moment>

export enum PlanningScope {
  Daily = 'daily',
  Monthly = 'monthly'
}
